export const GET_FITBIT_DATA = 'fitbit/GET_FITBIT_DATA';
export const GET_FITBIT_DATA_SUCCESS = 'fitbit/GET_FITBIT_DATA_SUCCESS';
export const GET_FITBIT_DATA_ERROR = 'fitbit/GET_FITBIT_DATA_ERROR';

export const SYNC_FITBIT_DATA = 'fitbit/SYNC_FITBIT_DATA';
export const SYNC_FITBIT_DATA_SUCCESS = 'fitbit/SYNC_FITBIT_DATA_SUCCESS';
export const SYNC_FITBIT_DATA_ERROR = 'fitbit/SYNC_FITBIT_DATA_ERROR';

export const GET_FITBIT_DATA_RANGE = 'fitbit/GET_FITBIT_DATA_RANGE';
export const GET_FITBIT_DATA_RANGE_SUCCESS = 'fitbit/GET_FITBIT_DATA_RANGE_SUCCESS';
export const GET_FITBIT_DATA_RANGE_ERROR = 'fitbit/GET_FITBIT_DATA_RANGE_ERROR';

export const GET_LATEST_FITBIT_DATA = 'fitbit/GET_LATEST_FITBIT_DATA';
export const GET_LATEST_FITBIT_DATA_SUCCESS = 'fitbit/GET_LATEST_FITBIT_DATA_SUCCESS';
export const GET_LATEST_FITBIT_DATA_ERROR = 'fitbit/GET_LATEST_FITBIT_DATA_ERROR';

export const SET_WEBSOCKET_CONNECTED = 'fitbit/SET_WEBSOCKET_CONNECTED';
export const UPDATE_FITBIT_DATA_FROM_WEBSOCKET = 'fitbit/UPDATE_FITBIT_DATA_FROM_WEBSOCKET';

export const CLEAR_FITBIT_ERROR = 'fitbit/CLEAR_FITBIT_ERROR';
export const RESET_FITBIT = 'fitbit/RESET_FITBIT';
